<div [id]="componentId" class="feature-loader">

  <section id="section-top">

    <div class="feature-animation">
      <app-shared-loading-g [animation]="animation"></app-shared-loading-g>
    </div>

  </section>

  <section id="section-bottom">

    <div class="feature-bar">

      @if (loginProgress) {
        <app-shared-loading-bar
          [ariaLabel]="'verifying-user-credentials-bar'"
          [barPercentile]="loginProgressPercentComplete"
          [barText]="loginTextAtCurrentStep"
          [isBaPercentileVisible]="true"
          [isBarTextVisible]="true"
          [isBorderVisible]="true"
          [isError]="isLoginError">
        </app-shared-loading-bar>
      }

    </div>

  </section>

</div>
